(function($) {
'use strict';

    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;

    if (isSafari) {

        $(window).resize(function () {
            $('.pf-fix-height-from-parent').each(function () {
                var parentHeight = $(this).parent().height();

                $(this).css('height', parentHeight);
            });
        });

        $(document).ready(function () {
            $(window).resize();
        });
    }

})(jQuery);
